<template>
  <b-nav-item-dropdown
    class="profile-menu"
    :no-caret="width > tabSize ? false : true"
  >
    <template #button-content>
      <b-avatar :src="profileImg" class="avatar" />
      <span v-if="width > tabSize" class="mx-2">{{ getUsername }}</span>
    </template>
    <b-dropdown-item to="/user/profile" class="profile-menu-item">
      <b-icon icon="person"></b-icon>
      حساب کاربری
    </b-dropdown-item>
    <b-dropdown-item to="/payment/add" class="profile-menu-item">
      <b-icon icon="credit-card"></b-icon>
      افزایش اعتبار
    </b-dropdown-item>
    <b-dropdown-item to="/payment/list" class="profile-menu-item">
      <b-icon icon="cash-stack"></b-icon>
      پرداخت ها
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item-btn
      v-on:click="logoutClicked"
      class="profile-menu-item logout"
    >
      <b-icon icon="power"></b-icon>خروج</b-dropdown-item-btn
    >
  </b-nav-item-dropdown>
</template>

<script>
import { logout } from "@/services/auth";
import { mapState, mapActions, mapGetters } from "vuex";
import {
  SIGNOUT_USER_SUCCESS,
  SHOW_MESSAGE,
  TAB_SIZE,
  GET_USERNAME
} from "@/store/mutation-types";

export default {
  name: "ProfileMenu",
  computed: {
    ...mapState("setting", ["width"]),
    ...mapGetters("header", [GET_USERNAME])
  },
  data() {
    return {
      tabSize: TAB_SIZE,
      profileImg: ""
    };
  },
  methods: {
    ...mapActions("auth", [SIGNOUT_USER_SUCCESS, SHOW_MESSAGE]),
    logoutClicked: async function() {
      const [error, data] = await logout({
        accessToken: localStorage.getItem("auth_access"),
        refreshToken: localStorage.getItem("auth_refresh")
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[SIGNOUT_USER_SUCCESS]();
          this.$router.replace("/login");
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.profile-menu {
  direction: ltr;
  &,
  & [role="button"] {
    &:focus {
      outline: none;
    }
  }
  .avatar {
    border: 2px solid #edf0f0;
    height: 36px;
    width: 36px;
    border-radius: 50%;
  }
  &-item {
    a {
      padding-top: 10px;
      padding-bottom: 10px;
      display: flex;
      align-items: center;
      font-size: 14px;
    }
    svg {
      margin-left: 10px;
    }
  }
  .logout button {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    &:focus {
      outline: none;
    }
  }
}
</style>
